import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { IndustrialConfiguratorPage } from '~/components/routes/industrial-configurator/industrial-configurator-page'
import { useFeatureFlag, useFeatureFlagsReady } from '~/hooks/useFeatureFlag'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/industrial-configurator')({
  staticData: {
    permission: ['read', 'previsions.industrial-configurator.kitchen'],
  },
  component: IndustrialConfiguratorRoute,
})

withRoutePermissions(Route)

function IndustrialConfiguratorRoute() {
  const featureEnabled = useFeatureFlag(FLAGS.configurateurIndustriel)
  const flagsReady = useFeatureFlagsReady()

  if (!flagsReady) {
    return <p className="p-4 text-sm text-muted-foreground">Chargement…</p>
  }

  if (!featureEnabled) {
    return <Navigate to="/" replace />
  }

  return <IndustrialConfiguratorPage />
}
